const baseURL = "/v1/Grupo";

const service = {
  methods: {
    $buscarAbas(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $buscarTodasPermissoes(params) {
      return this.$api().get(`${baseURL}/Permissoes`, params);
    },
    $visualizarAbas({ params, id }) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $cadastrarAba(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarAba(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarAba(body, id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`, body);
    },
    $excluirAba(body, id) {
      return this.$api().delete(`${baseURL}/${id}`, body);
    },
    $detalharUsoAba({ id, params}) {
      return this.$api().get(`${baseURL}/DetalharUso/${id}`, params);
    },
  },
};

export default service;
